export default __webpack_public_path__ + "static/media/WhackAWord_0323.69d2f442.svg";